export enum RoutesName {
  HANDOVER_LOG = 'handover-log',
  SHIFT_LOG = 'shift-log',
  HIGH_ALERTS = 'high-alerts',
  WORLD_CLOCK = 'world-clock',
  FORBIDDEN = '403',
}

export const ROUTES_ORDER = [RoutesName.WORLD_CLOCK, RoutesName.SHIFT_LOG, RoutesName.HANDOVER_LOG, RoutesName.HIGH_ALERTS];
